//hooks
import { useState, useEffect } from 'react';
import { useApi } from '../../hooks/useApi';

//css file
import styles from './carousel.module.css'

//translate
import i18n from '../../translate/i18n';

//type
import { GetSliderTypeRes } from '../../api/slider/type/GetSliderType';

//api
import { GetSliderImags } from '../../api/slider/GetSliderImags';

//mui
import CircularProgress from '@mui/material/CircularProgress';
import ReplayIcon from '@mui/icons-material/Replay';


const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;



const Carousel = () => {
  const [current, setCurrent] = useState(0);
    let [sliderImage, setSliderImage] = useState<GetSliderTypeRes[]>([]);

    const {
      loading:homeSliderLoading,
      error:homeSliderError,
      HandlerApi:homeSliderApi,
    } = useApi(GetSliderImags, "GET");

  useEffect(() => {
    const fetchData = async () => {
      const homeSliderSection = await homeSliderApi();
      setSliderImage(homeSliderSection.data || []);
      };
    fetchData();
  }, []);


  const length = sliderImage.length ;
  const nextSlide = () => setCurrent((current + 1) % length);
  const prevSlide = () => setCurrent((current - 1 + length) % length);
  const goToSlide = (index: number) => setCurrent(index);

  return (
    <div className={`relative w-full max-md:h-72 md:h-[800px] ${i18n.language === "en" ? "font-palab" : "font-helvetica-arabic-bold"} overflow-hidden`}>
      {homeSliderLoading 
      ? 
      <div className='flex justify-center h-full'>
        <CircularProgress className='m-auto'/>
      </div>
      :
      homeSliderError
      ?
      <div className='cursor-pointer flex justify-center h-full'>
        <ReplayIcon onClick={homeSliderApi} className='!text-[40px] m-auto' />
      </div>
      :
      <>
        {/* Slides wrapper */}
        <div
          className="flex transition-transform duration-700 ease-in-out h-full"
          style={{ transform: `translateX(-${current * 100}%)` }}
        >
          {sliderImage.map((src, index) => (
            <div key={index} className={`${styles.Slides} relative flex-shrink-0 w-full h-full`}>
              <img
                src={`${storageURL}/${src.url}`}
                alt={`Slide ${index + 1}`}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className="absolute z-30 flex -translate-x-1/2 bottom-5 left-1/2 space-x-3">
          {sliderImage.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-5 h-5 max-md:w-3 max-md:h-3 rounded-full ${
                index === current ? 'bg-secondaryColor' : 'bg-gray-400'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            ></button>
          ))}
        </div>

        {/* Arrows */}
        <button
          onClick={prevSlide}
          className="absolute top-0 left-0 z-30 flex items-center justify-center h-full px-4"
        >
          <span className="inline-flex w-10 h-10 bg-secondaryColor rounded-full items-center justify-center hover:bg-white/50">
            <svg
              className="w-4 h-4 text-primaryColor"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 6 10"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 1L1 5l4 4" />
            </svg>
          </span>
        </button>

        <button
          onClick={nextSlide}
          className="absolute top-0 right-0 z-30 flex items-center justify-center h-full px-4"
        >
          <span className="inline-flex w-10 h-10 bg-secondaryColor rounded-full items-center justify-center hover:bg-white/50">
            <svg
              className="w-4 h-4 text-primaryColor"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 6 10"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 9l4-4-4-4" />
            </svg>
          </span>
        </button>
      </>
    }
    </div>
  );
};

export default Carousel;
